import styled from 'styled-components';

const Inner = styled.div`
  max-width: ${({ theme }) => theme.maxWidth};

  height: 100%;
  margin: 0 auto;
  padding: 0 1.5rem;
`;

const Section = styled.section`
  margin: 2rem 0;
`;

export { Inner, Section };
